import React from "react"
import styled from "@emotion/styled"
import { css, Global } from "@emotion/core"
import Footer from "components/Common/Footer"
import SignUpBox from "components/Auth/SignUpBox"
import t, { mixin, globalStyle } from "theme"
import { useMediaQuery } from "react-responsive"
import "../../content/dricons.css"

const Layout = ({ header, sidebar, isHome = false, uniqueComponent, children, ...props }) => {
    return (
        <GridLayout isHome={isHome} {...props}>
            <Global styles={globalStyle} />
            <div
                css={css`
                    grid-area: head;
                `}>
                {header}
            </div>

            {isHome ? (
                <div
                    css={css`
                        grid-area: caru;
                        ${mixin.desktopstyle} {
                            display: none;
                        }
                    `}>
                    {uniqueComponent}
                </div>
            ) : null}

            <div
                css={css`
                    grid-area: feat;
                    ${mixin.defaultEndsPadding}
                `}>
                {sidebar}
            </div>

            <SignUpBox
                css={css`
                    grid-area: sign;
                `}
            />

            <div
                css={css`
                    grid-area: cont;
                    ${mixin.defaultEndsPadding}
                `}>
                {children}
            </div>

            <Footer
                css={css`
                    grid-area: foot;
                `}
            />
        </GridLayout>
    )
}

export default Layout

/*
<div
css={css`
    grid-area: caru;
`}>
{uniqueComponent}
</div>
*/

/*
const homeMobileLayout = `
"   head    head    head    "
"   .       caru    .       "
"   .       feat    .       "
"   .       cont    .       "
"   foot    foot    foot    "
`
*/

const homeMobileLayout = `
"   head    head    head    "
"   .       caru    .       "
"   .       feat    .       "
"   .       cont    .       "
"   .       sign    .       "
"   foot    foot    foot    "
`

const regularMobileLayout = `
"   head    head    head    "
"   .       cont    .       "
"   .       feat    .       "
"   .       sign    .       "
"   foot    foot    foot    "
`

const GridLayout = styled.div`
    display: grid;
    min-height: 100vh;
    width: 100%;
    overflow-x: hidden;
    grid-template-areas:
        "   head    head    head    head    head    "
        "   .       cont    .       feat    .       "
        "   .       cont    .       sign    .       "
        "   foot    foot    foot    foot    foot    ";
    grid-template-rows: max-content max-content auto max-content;
    grid-template-columns:
        minmax(0vw, ${t.sitewide.sideWidth}) 2fr ${t.space[9]}
        minmax(16rem, 0.85fr) minmax(0vw, ${t.sitewide.sideWidth});
    grid-column-gap: 0px;

    ${mixin.tabletandphonestyle} {
        grid-template-columns: 10vw 1fr 10vw;
        grid-template-rows: ${({ isHome }) =>
            isHome
                ? "max-content max-content max-content max-content max-content max content"
                : "max-content max-content max-content max-content max content"};
        grid-template-areas: ${({ isHome }) => (isHome ? homeMobileLayout : regularMobileLayout)};
        grid-row-gap: 0;
    }
    ${mixin.phonestyle} {
        grid-template-columns: 5vw 1fr 5vw;
    }
`
